import React, { Component } from 'react'
import { translationHook } from '../translationHook'
import { triggerDialog, triggerDialogForm, setLoading, triggerNotification } from '../../actions'
import { connect } from 'react-redux'
import { getUsersList } from './../../apis/system/getUsersList'
import { deleteUser } from './../../apis/system/deleteUser'
import CustomStore from 'devextreme/data/custom_store'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import VisibilityIcon from '@material-ui/icons/Visibility'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import { setUserStatus } from './../../apis/system/setUserStatus'
import {
	DataGrid,
    Column,
    Button,
    SearchPanel,
    FilterRow,
    HeaderFilter,
    ColumnChooser,
	Export,
	Grouping,
	GroupPanel,
	Selection
} from 'devextreme-react/data-grid';
import AvatarImg from '../../images/avatar.png';

import { ExcelJS , Workbook } from "exceljs";
import saveAs from "file-saver";
import { exportDataGrid as exportDataGridToExcel } from "devextreme/excel_exporter";

import { 
    ButtonSecondary, 
    ButtonDanger, 
    ButtonInfo,
    ButtonWarning 
} from './../UI/Buttons'

class UsersList extends Component {
    constructor(props){
		super(props);
		this.onExporting = this.onExporting.bind(this);
	}
    handleDelete = data => {
        let at = this.props.currentUser.Data.access_token,
        userAccountId = data.User_Account_Id,
        userName = this.props.i18n.language === 'ar' ? data.User_Name_AR : data.User_Name_EN,
        dialogTitle = `${this.props.t('confirmDeleteTitle')} ${userName}`,
        dialogMsg = this.props.t('confirmDeleteMsg')

        this.props.triggerDialog(true, {
            title: dialogTitle,
            message: dialogMsg,
            action: {
                action: deleteUser,
                params: [
                    at,
                    userAccountId
                ],
                text: this.props.t('deleteUser')
            }
        })
    }

    imgPreview = ({data}) => {
        return (
            <img 
                src={data.User_Image === '' ? AvatarImg : data.User_Image} 
                style={{width: '50px', height: '50px', objectFit: 'cover'}}
            />
        )
    }
    loginName = ({data}) => {
        return (
            <div class="d-flex justify-content-between align-content-center">
                {data.Login_Name}
                {data.AD_Ref && (
                <span className="bg-danger text-white p-1 rounded mx-2">AD</span>
                )}
            </div>
        )
    }
    emailRender = ({data}) => {
        return (
            <div class="d-flex justify-content-between align-content-center">
                {data.User_Mail}
                {data.User_Mail_Verified === 1 && (
                <span className="bg-success text-white p-1 rounded mx-2">{this.props.t('verified')}</span>
                )}
            </div>
        )
    }
    
    phoneRender = ({data}) => {
        return (
            <div class="d-flex justify-content-between align-content-center">
                {data.User_Phone}
                {data.User_Phone_Verified === 1 && (
                <span className="bg-success text-white p-1 rounded mx-2">{this.props.t('verified')}</span>
                )}
            </div>
        )
    }

    customizeCellCheckbox = ({data}) => {
        // let label = this.props.i18n.language === 'ar' ? data.Active_Status_Name_AR : data.Active_Status_Name_EN
        return (
            <FormControlLabel
                control={
                    <Switch
                        checked={data.Active_Status_Id}
                        name='userStatus'
                        onChange={async () => {
                            let at = this.props.currentUser.Data.access_token,	
                            userId = data.User_Account_Id,
                            status = data.Active_Status_Id ? 0 : 1

                            this.props.setLoading(true, 'dark')

                            const response = await setUserStatus(at, userId, status)

                            this.props.triggerNotification(true, response)

                            this.props.setLoading(false)

                        }}
                    />
                }
                // label={label}
            />
        )
    }

    render() {

        let columnAlign = 'left',
        UserNameKey = 'User_Name_EN',
        UserTypeNameKey = 'User_Type_Name_EN',
        UserGroupNameKey = 'User_Group_Name_EN',
        DepartmentNameKey = 'Department_Name_EN',
        DepartmentJobKey = 'Department_Job_Name_EN',
        at = this.props.currentUser.Data.access_token

        if  (this.props.i18n.language === 'ar') {
            columnAlign = 'right'
            UserNameKey = 'User_Name_AR'
            UserTypeNameKey = 'User_Type_Name_AR'
            UserGroupNameKey = 'User_Group_Name_AR'
            DepartmentNameKey = 'Department_Name_AR'
            DepartmentJobKey = 'Department_Job_Name_AR'
        }

        const jsonDataSource = new CustomStore({
            key: 'User_Id',
            load: () => {
                return getUsersList(at)
            }
        })

        return (
            <>
                <DataGrid
					className={[this.props.i18n.language === 'ar' ? 'dx-grid-ar' : 'dx-grid-en' , 'globalBox'].join(' ')}
					id="dataGrid"
					width={'100%'}
					dataSource={jsonDataSource}
					showBorders={false}
					showColumnLines= {false}
					showRowLines= {true}
					allowColumnResizing={true}
					columnResizingMode={'widget'}
					allowColumnReordering={true}
					rowAlternationEnabled={false}
					focusedRowEnabled={true}
					onExporting={this.onExporting}
					// columnWidth={'auto'}
					wordWrapEnabled={true}
					rtlEnabled = {this.props.i18n.language === 'ar' ? true : false}
				>

					<ColumnChooser enabled={true} allowSearch={true} search={'fff'}
						title={this.props.t('dxColumnChooserTitle')}
						emptyPanelText={this.props.t('dxColumnChooserPanelText')}
					/>
					
					<SearchPanel 
						visible={true}
						width={240}
						placeholder={this.props.t('search')}
					/>

					<FilterRow visible={true} />

					<HeaderFilter visible={true} />

					<Export enabled={true} allowExportSelectedData={true}/>

					<Grouping contextMenuEnabled={true} expandMode="rowClick"/>
                	<GroupPanel visible={true} emptyPanelText={this.props.t('dxGroupPanelText')}/>

					<Selection
						mode="multiple"
						selectAllMode={'allPages'}
						showCheckBoxesMode={'always'}
					/>
                    
                    <Column
                        dataField='User_Image' 
                        caption={this.props.t('userImage')}
                        alignment='center'
                        cellRender={this.imgPreview}
                        width={120}
                    >
                    </Column>

                    <Column 
                        dataField={UserNameKey} 
                        caption={this.props.t('userName')} 
                        alignment={columnAlign}
                    >
                    </Column>
                    <Column 
                        cssClass="outlinedColumn"
                        dataField='Login_Name'
                        caption={this.props.t('loginName')} 
                        alignment={columnAlign}
                        cellRender={this.loginName}

                    >
                    </Column>
                    <Column 
                        dataField='User_Mail' 
                        caption={this.props.t('mail')}
                        alignment={columnAlign}
                        cellRender={this.emailRender}
                    >
                    </Column>
                    <Column
                        cssClass="outlinedColumn" 
                        dataField='User_Phone' 
                        caption={this.props.t('phone')}
                        alignment={'center'}
                        cellRender={this.phoneRender}
                        width={220}
                    >
                    </Column>
                    <Column cssClass="outlinedColumn"
                        dataField="Active_Status_Id" 
                        caption={this.props.t('userStatus')} 
                        allowFiltering={false}
                        alignment='center'
                        cellRender={this.customizeCellCheckbox}
                        width={100}
                    >
                    </Column>

                    <Column 
                        dataField={UserTypeNameKey} 
                        caption={this.props.t('userTypeName')}
                        alignment={columnAlign}
                        visible={false}
                    >
                    </Column>

                    <Column cssClass="outlinedColumn"
                        dataField={UserGroupNameKey} 
                        caption={this.props.t('userGroupName')}
                        alignment={'center'}
                        visible={false}
                    >
                    </Column>

                    <Column 
                        dataField={DepartmentNameKey} 
                        caption={this.props.t('departmentName')}
                        alignment={columnAlign}
                        visible={false}
                    >
                    </Column>
                    <Column 
                        dataField={DepartmentJobKey} 
                        caption={this.props.t('departmentJob')}
                        alignment={columnAlign}
                        visible={false}
                    >
                    </Column>


                    <Column cssClass="outlinedColumn nowrapColumn"
						type='buttons'
						caption={this.props.t('details')}
						fixed={true}
						fixedPosition={this.props.i18n.language === 'ar' ? 'left' : 'right'}
					>

                        <Button
                            render={(record) => {
                                return (
                                    <ButtonWarning
                                        variant="circleIcon"
                                        startIcon={<EditIcon />}
                                        onClick={() => {
                                            this.props.triggerView(false, true)

                                            this.props.handleEdit(record.data)
                                        }}
                                    >
                                        {/* {this.props.t('edit')} */}
                                    </ButtonWarning>
                                )
                            }}
                        />

                        <Button
                            render={(record) => {
                                return (
                                    
                                    <ButtonInfo
                                    variant="circleIcon"
                                    startIcon={<VisibilityIcon />}
                                    onClick={() => {
                                        this.props.triggerView(true, false)

                                        this.props.handleEdit(record.data)
                                    }}
                                    >
                                        {/* {this.props.t('view')} */}
                                    </ButtonInfo>
                                )
                            }}
                        />
                            
                        <Button
                            render={(record) => {
                                return (
                                    <ButtonDanger
                                        variant="circleIcon"
                                        startIcon={<DeleteIcon />}
                                        onClick={() => this.handleDelete(record.data)}
                                    >
                                        {/* {this.props.t('delete')} */}
                                    </ButtonDanger>
                                )
                            }}
                        />

                    </Column>

                </DataGrid>
            </>
        )
    }
    
	onExporting(e) {
		let sheetTitle = this.props.t('manageUsers')
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGridToExcel({
            component: e.component,
            worksheet: worksheet,
			autoFilterEnabled: true,
			topLeftCell: { row: 2, column: 2 },
			topRightCell: { row: 2, column: 2 },
            customizeCell: ({gridCell, excelCell}) => {
                // excelCell.value = gridCell.value;
                excelCell.font = { family: 2, name: 'Cairo', size: 10, color: {argb: "151713"} };
				excelCell.alignment = { indent: 1, wrapText: true, vertical: 'middle' };
				if(gridCell.rowType === 'group') {
					excelCell.fill = {
						type: 'pattern',
						pattern:'solid',
						fgColor:{argb:'d0b166'}
					  };
					excelCell.alignment = { indent: 2 };
					excelCell.font = { family: 2, name: 'Cairo', size: 10, color: {argb: "ffffff"}, bold: true };
				}
				if(gridCell.rowType === 'header') {
				excelCell.fill = {
					type: 'pattern',
					pattern:'solid',
					fgColor:{argb:'58743a'}
					};
				excelCell.alignment = { vertical: 'middle', horizontal: 'center' };
				excelCell.font = { family: 2, name: 'Cairo', size: 12, color: {argb: "ffffff"}, bold: true };
				}
            } 
        }).then(function() {
            workbook.xlsx.writeBuffer()
                .then(function(buffer) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${sheetTitle}.xlsx`);
                });
        });
        e.cancel = true;
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser,
        reload: state.reload,
    }
}

export default connect(mapStateToProps, { triggerDialog, triggerDialogForm, setLoading, triggerNotification })(
	translationHook(UsersList)
)
